import BenefitManagementStore from "stores/BenefitsManagementStore";
import {Formik} from "formik";

import "./BenefitsDetailForm.scss";

import React, {useState} from "react";
import {Benefit} from "models/Benefit";
import DataForm from "../BenefitForm/BenefitForm";
import DeleteButton from "./components/DeleteButton";
import {useHistory} from "react-router-dom";
import Button from "components/commons/Button/Button";
import AppStore from "stores/AppStore";
import Modal from "components/commons/Modal/Modal";


const BenefitDetailForm = () => {
  const { benefit } = BenefitManagementStore;
  const history = useHistory();
  const { i18n: { benefits: { save } } } = AppStore;
  const [blockedByEmployees, setBlockedByEmployees] = useState<string[] | null>(null);

  const handleSubmit = (values: Benefit, { resetForm }) => {
    BenefitManagementStore.putBenefit({ ...values, price: { value: Math.round(values.price.value * 100) } })
      .then(() => history.push("/benefits"))
      .catch((err) => {
        if (err && err.employeeIds) {
          setBlockedByEmployees(err.employeeIds);
          resetForm();
        }
      })
  }

  const initialValues = { ...benefit, price: { value: benefit.price.value / 100 } };

  return (
    <div className="c-benefit-form">
      <Formik initialValues={initialValues} onSubmit={handleSubmit}>
        {({ submitForm, isValid }) => (
          <DataForm>
            <div className="c-benefit-form__actions">
              <Button className="c-benefit-form__action-button" text={save} onClick={submitForm} disabled={!isValid} />
              <DeleteButton />
            </div>
          </DataForm>
        )}
      </Formik>
      <Modal
        isModalVisible={!!blockedByEmployees}
        onClose={() => setBlockedByEmployees(null)}
        onAccept={() => setBlockedByEmployees(null)}
        title="Cannot deactivate benefit"
        acceptText="OK"
        hideCancel
      >
        <p>This benefit is assigned to the following employees:</p>
        <ul>
          {blockedByEmployees && blockedByEmployees.map(id => <li key={id}>{id}</li>)}
        </ul>
      </Modal>
    </div>
  )
}


export default BenefitDetailForm;